import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import NotiFyItem from '../NotifyItem/NotiFyItem';

import styles from './Notifys.module.css';

export default class Notifys extends Component {
    static propTypes = {
        notifications: PropTypes.arrayOf(PropTypes.shape({
            /*id: PropTypes.number.isRequired,
            author: PropTypes.string.isRequired,
            modId: PropTypes.number.isRequired,
            title: PropTypes.string.isRequired,
            spaId: PropTypes.number.isRequired,
            isUpdated: PropTypes.bool.isRequired,
            createdAt: PropTypes.string.isRequired,
            content: PropTypes.string.isRequired,*/
            type: PropTypes.number, // 0 - all for site, 1 - following, 2 - reports, 3 - support
            objectId: PropTypes.number,
            //spaId: PropTypes.number,
            updatedAt: PropTypes.string,
            content: PropTypes.string,
        })),

        onIgnoreNotify: PropTypes.func,
    }

    renderItem(item, index) {
        return (
            <NotiFyItem
                id={index}
                key={index}
                /*id={item.id}
                author={item.author}
                modId={item.modId}
                title={item.title}
                spaId={item.spaId}
                isUpdated={item.isUpdated}
                createdAt={item.createdAt}
                content={item.content}*/
                type={item.type}
                objectId={item.objectId}
                //spaId={item.spaId}
                updatedAt={item.updatedAt}
                content={item.content}

                onIgnoreNotify={this.props.onIgnoreNotify}
            />
        )
    }

    renderNotifications = () => {
        const sortedNotifications = this.props.notifications.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
        
        return sortedNotifications.map((item, index) => this.renderItem(item, index))
    }
    
    render() {
        return (
            <div className={classNames(styles.cm_scroll, styles.cm_scroll__notifications, 'js-cm-scroll-wrapper')}>
                <ul className={classNames(styles.cm_scroll_container,"js-cm-notifications-list")} style={{overflow: 'visible', maxHeight: '249px'}}>
                    {this.renderNotifications()}
                </ul>
                <div className={classNames(styles.cm_scroll_track, "js-cm-scrollbar-track")}>
                    <div className={styles.cm_scroll_thumb}></div>
                </div>
            </div>
        )
    }
}
